import { Component, OnInit }       from '@angular/core';
import { Router }  from '@angular/router';
import { Location }        from '@angular/common';

import { CallService } from '../services/calls/call.service';

import { Call } from '../classes/call';

import { specialties } from '../users/specialties.component'

import * as _ from 'lodash';
import { DoctorService } from '../services/doctors/doctor.service';
import { ProviderService } from '../services/providers/provider.service';
import { PatientService } from '../services/patients/patient.service';
import { CallTagService } from '../services/callTag/call.tag.service';
import { SpecialtiesService } from '../services/specialties/specialties.service';
import { FilterService } from '../services/calls/filter.service';

import { Doctor } from '../classes/doctor';
import { Patient } from '../classes/patient';
import { CallTag } from '../classes/callTag';

var Moment = require('moment');

@Component({
  moduleId: module.id,
  selector: 'create-call',
  templateUrl: 'createCall.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class CreateCallComponent implements OnInit{

  // -------- Doctors
  allDoctors;
  selectedDoctorIndex;
  selectedDoctor:Doctor;

  doctorSpecialties;
  selectedSpecialtyIndex;
  selectedSpecialty;

  doctorName;
  doctorEmail;

  // -------- Patients
  allPatients;
  selectedPatientIndex;
  selectedPatient:Patient;

  //Multiple calls
  patientListString;
  patientsWithErrorMessage;
  createdCallsCount;
  callsToCreateTotal;
  selectedProviderIndexMultiple;
  selectedProviderMultiple;
  errorMessage;

  providers;
  selectedProviderIndex;
  selectedProvider;

  patientName;
  patientEmail;
  patientDocumentNumber;
  patientFamilyGroup;

  selectedCaller;
  selectedCallerIndex;
  loggedPatientsInFamilyGroup;

  // -------- Tags
  selectedTag;
  selectedAddedTag;
  callTags:string[] = [];
  availableTags:CallTag[] = [];
  removedTags:CallTag[] = [];

  callDatetime;

  limit = 150;

  constructor(protected callService: CallService,
              protected location: Location,
              protected doctorsService: DoctorService,
              protected patientsService: PatientService,
              protected specialtiesService:SpecialtiesService,
              protected providerService: ProviderService,
              protected callTagService: CallTagService,
              protected filterService: FilterService,
              protected router: Router) { }

  ngOnInit(): void {
    this.providerService.getAll().then((providers)=>{
      this.providers = providers.filter( provider => !provider.deprecated );
    })
    this.callTagService.getAll().then(tags => {
      this.availableTags = tags;
    });
    this.getSpecialties()
    this.callDatetime = this.filterService.getCurrentDate();
  }

  getSpecialties(){
    this.specialtiesService.getAll().then((response)=>{
      this.doctorSpecialties=response
    })
  }

  doctorSelected(event): void {
    this.selectedDoctor = this.allDoctors[this.selectedDoctorIndex];
  }

  specialtySelected(event): void {
    if(this.selectedSpecialtyIndex != 0)
      this.selectedSpecialty = this.doctorSpecialties[this.selectedSpecialtyIndex-1];
    else
      this.selectedSpecialty = undefined;
  }

  searchDoctors(): void {
    this.selectedDoctorIndex = undefined;
    let params = {};

    if(this.doctorName) params['name'] = this.doctorName;
    if(this.doctorEmail) params['email'] = encodeURIComponent(this.doctorEmail);
    if(this.selectedSpecialty) params['specialty'] = this.selectedSpecialty.id;

    this.doctorsService.get(params).then((doctors: any[]) => this.allDoctors = doctors)
  }

  resetDoctors() {
    this.doctorName = undefined;
    this.doctorEmail = undefined;
    this.selectedSpecialtyIndex = undefined;
    this.selectedDoctorIndex = undefined;
    this.doctorsService.get({limit:this.limit}).then((doctors: any[]) => this.allDoctors = doctors)
  }

  patientSelected(event): void {
    this.selectedPatient = this.allPatients[this.selectedPatientIndex];
    this.selectedCallerIndex = undefined;
    this.selectedCaller = undefined;
    this.getFamilyGroup();
  }

  selectCaller(event): void {
    this.selectedCaller = this.loggedPatientsInFamilyGroup[this.selectedCallerIndex-1];
  }

  getFamilyGroup(){
    this.patientsService.getFamily(this.selectedPatient.familyGroup)
      .then(users => {
        this.patientFamilyGroup = users.members;
        if (this.patientFamilyGroup.length <= 1 || this.selectedPatient.hasLoggedIn) {
          this.selectedCaller = this.selectedPatient;
        } else {
          this.loggedPatientsInFamilyGroup = this.patientFamilyGroup.filter(member => member.hasLoggedIn === true)
          console.log(this.loggedPatientsInFamilyGroup)
        }
    })
  }

  providerSelected(event): void {
    if(this.selectedProviderIndex != 0)
      this.selectedProvider = this.providers[this.selectedProviderIndex-1];
    else
      this.selectedProvider = undefined;
  }

  providerSelectedMultiple(event): void {
    if(this.selectedProviderIndexMultiple)
      this.selectedProviderMultiple = this.providers[this.selectedProviderIndexMultiple - 1];
  }

  searchPatients(): void {
    this.selectedPatientIndex = undefined;
    this.selectedCallerIndex = undefined;
    let params = {
      limit: this.limit,
      createManual: true
    };

    if(this.patientName) params['name'] = this.patientName;
    if(this.patientEmail) params['email'] = encodeURIComponent(this.patientEmail);
    if(this.patientDocumentNumber) params['documentNumber'] = this.patientDocumentNumber;
    if(this.selectedProvider) params['provider'] = this.selectedProvider.id;

    this.patientsService.getForTable(params).then((patients: any[]) => this.allPatients = patients)
  }

  resetPatients() {
    this.patientName = undefined;
    this.patientEmail = undefined;
    this.patientDocumentNumber = undefined;
    this.selectedProviderIndex = undefined;
    this.selectedPatientIndex = undefined;
    this.selectedCallerIndex = undefined;
    this.patientsService.getForTable({limit:this.limit}).then((patients: any[]) => this.allPatients = patients)
  }

  resetPatientsList() {
    this.selectedProviderIndexMultiple = undefined;
    this.selectedProviderMultiple = undefined;
    this.patientListString = undefined;
    this.selectedDoctor = undefined;
    this.selectedDoctorIndex = undefined;
  }

  addSelectedTag(){
    if(this.selectedTag) {
      let self = this;
      this.callTags.push(this.selectedTag);
      this.callTags.sort();
      this.removedTags = this.removedTags.concat(_.remove(this.availableTags, function(item){ return item.name == self.selectedTag}));
      this.selectedTag = undefined;
    }
  }

  removeSelectedTag(){
    if(this.selectedAddedTag) {
      let self = this;
      _.remove(this.callTags, function(item){ return item == self.selectedAddedTag});
      this.availableTags = this.availableTags.concat(_.remove(this.removedTags, function(item){ return item.name == self.selectedAddedTag}));
      this.availableTags = _.sortBy(this.availableTags.concat(this.removedTags), ['name']);
      this.selectedAddedTag = undefined;
    }
  }

  resetTags(){
    this.callTags = [];
    this.availableTags = _.sortBy(this.availableTags.concat(this.removedTags), ['name']);
    this.removedTags = [];
  }

  createCall(){
    if(this.selectedDoctor && this.selectedPatient && this.selectedCaller)
    {
      var datetime;

      if(this.callDatetime)
        datetime = Moment(this.callDatetime).toISOString();
      else
        datetime = Moment().toISOString();

      let body = {
        doctor: this.selectedDoctor.id,
        patient: this.selectedPatient.id,
        provider: this.selectedPatient.provider.id,
        caller: this.selectedCaller.id,
        createdAt: datetime,
        manual:true,
        tags: this.callTags
      }

      this.callService.createCall(body).then((call:Call) => {
        window.location.reload();
      }).catch((err)=>{

        return err && err._body ?
              (err._body.message ? alert(err._body.message) : alert(err))
              : alert(err);
      })
    }
  }

  createMultipleCalls(){
    if(this.selectedDoctor && this.patientListString && this.selectedProviderMultiple && !_.isEmpty(this.patientListString.trim()))
    {
      this.createdCallsCount = 0;
      let datetime;
      if(this.callDatetime)
        datetime = Moment(this.callDatetime).toISOString();
      else
        datetime = Moment().toISOString();

      let patientList = this.patientListString.replace(/\r/g, "").split(/\n/);
      this.callsToCreateTotal = patientList.length;
      this.patientsWithErrorMessage = patientList.join("<br>");
      this.errorMessage = undefined;

      patientList.forEach(patientId => {
        patientId = patientId.trim();
        let params = {
          limit: this.limit,
          documentNumber: patientId,
          provider: this.selectedProviderMultiple.id
        };

        this.patientsService.getByProviderAndDocumentNumber(params).then((foundPatient) => {

          if(foundPatient) {
            let body = {
              doctor: this.selectedDoctor.id,
              patient: foundPatient.id,
              provider: _.isObject(foundPatient.provider) ? foundPatient.provider.id : foundPatient.provider,
              //pongo el caller como el mismo que es patient
              caller: foundPatient.id,
              createdAt: datetime,
              manual:true,
              tags: this.callTags
            }
            console.log("creando llamada para:");
            console.log(body)

            this.callService.createCall(body).then((call:Call) => {
              _.remove(patientList, function(item){ return item == patientId.trim()});
              this.patientListString = patientList.join("\r\n");
              this.patientsWithErrorMessage = patientList.join("<br>");
              this.createdCallsCount++;
            }).catch((err)=>{
              if(err._body) this.errorMessage = err._body.message
              console.log(err);
            })
          }
          else {
            console.log("Couldnt find patient with id '" + patientId + "'");
          }
        })
        .catch(error => {
          //remove patient from list
          console.log("Error while searching for patient " + patientId)
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/calls/createCall.component.ts